module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "five-nav flex-start"
  }, _vm._l((9), function(i) {
    return _c('div', {
      key: i,
      staticClass: "nav-buttom"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/images/pic-homepage-active1.png"),
        "alt": "",
        "srcset": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v("赛事活动")])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57d137c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/navButton.vue
// module id = 1492
// module chunks = 0